import car from "assets/images/CAR.svg"
import {  useSelector } from 'react-redux';

export const editDriverDialogData = (details) =>[
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'vendorName',
    label: 'Driver Name',
    countrycode: false,
    defaultValue: details?.name || '',
  },
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'name',
    label: 'City Manager',
    countrycode: false,
    defaultValue: details?.vendorName || '',
    disabled: true,
  },
  {
    placeholder: 'Mobile Number',
    required: false,
    type: 'text',
    name: 'number',
    label: 'Mobile Number',
    countrycode: true,
    defaultValue:details?.mobile?.replaceAll("+91","") || '',
  },
  {
    placeholder: 'Email',
    required: false,
    type: 'text',
    name: 'email',
    label: 'Email',
    countrycode: false,
    defaultValue:details?.email || '',
  }
];
export const editSubDriverDialogData = (details) =>[
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'vendorName',
    label: 'Driver Name',
    countrycode: false,
    defaultValue: details?.name || '',
  },
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'name',
    label: 'City Manager',
    countrycode: false,
    defaultValue: details?.vendorName || '',
    disabled: true,
  },
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'subVendorName',
    label: 'Sub-Vendor Name',
    countrycode: false,
    defaultValue: details?.subVendorName || '',
    disabled: true,
  },
  {
    placeholder: 'Mobile Number',
    required: false,
    type: 'text',
    name: 'number',
    label: 'Mobile Number',
    countrycode: true,
    defaultValue:details?.mobile?.replaceAll("+91","") || '',
  },
  {
    placeholder: 'Email',
    required: false,
    type: 'text',
    name: 'email',
    label: 'Email',
    countrycode: false,
    defaultValue:details?.email || '',
  },
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'address',
    label: 'Address & Street',
    multiline: true,
    row: 5,
    defaultValue:details?.location || '',
  },
  {
    placeholder: 'District',
    required: false,
    type: 'text',
    name: 'district',
    label: 'District',
    countrycode: false,
  },
  {
    placeholder: 'State',
    required: false,
    type: 'text',
    name: 'state',
    label: 'State',
    countrycode: false,
  },
];

export const vehicleInfo = (vehicleInfotable)=>[
  
  {
    title: 'Model Name',
    body: vehicleInfotable?.carModel,
  },
  {
    title: 'Vehicle no',
    body: vehicleInfotable?.regNumber,
  },
  {
    title: 'Vehicle Color',
    body: vehicleInfotable?.colour,
  },
  {
    title: 'Fuel type',
    body: vehicleInfotable?.fuelType,
  },
  {
    title: 'Vehicle Capacity',
    body: vehicleInfotable?.seating,
  },
  {
    title: 'Category',
    body: vehicleInfotable?.carType,
  },
  {
    title: 'Chasis No',
    body: vehicleInfotable?.chasisNum,
  },
  {
    title: 'Engine no',
    body: vehicleInfotable?.engineNum,
  },
]

export const vehicleImage = [
  {
    label: 'Front',
    imgPath:
      'https://images.unsplash.com/photo-1537944434965-cf4679d1a598?auto=format&fit=crop&w=400&h=250&q=60',
  },
  {
    label: 'Back',
    imgPath:
      'https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60',
  },
  {
    label: 'Right Side',
    imgPath:
      'https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250',
  },
  {
    label: 'Left Side',
    imgPath:
      'https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60',
  },
  {
    label: 'car',
    imgPath:'https://images.unsplash.com/photo-1503376780353-7e6692767b70?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80'
  }
];


export const amenitiesVehicle =(vehicleInfoaminities) => [
  {
    id:1,
    image:car,
    title: 'Stepney',
    body:vehicleInfoaminities?.stepney,
  },
  {
    id:2,
    image:car,
    title: 'Fire Extinguisher',
    body:vehicleInfoaminities?.fireExtinguisher,
  },
  {
    id:3,
    image:car,
    title: 'First-aid Kit',
    body:vehicleInfoaminities?.firstAid,
  },
  {
    id:4,
    image:car,
    title: 'Last Vehicle inspection',
    body:vehicleInfoaminities?.lastInspection,
  },
  {
    id:5,
    image:car,
    title: 'Last Service Date',
    body:vehicleInfoaminities?.lastService,
  },
  {
    id:6,
    image:car,
    title: 'Last Service Meter Reading',
    body:vehicleInfoaminities?.lastMeterReading,
  },
  {
    id:7,
    image:car,
    title: 'Average',
    body:vehicleInfoaminities?.average,
  },
]